import { render, staticRenderFns } from "./inspeccion-manual-form.vue?vue&type=template&id=bc006e4a&scoped=true"
import script from "./inspeccion-manual-form.vue?vue&type=script&lang=js"
export * from "./inspeccion-manual-form.vue?vue&type=script&lang=js"
import style0 from "./inspeccion-manual-form.vue?vue&type=style&index=0&id=bc006e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc006e4a",
  null
  
)

export default component.exports